import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';  ///----------- for searching pop up -----------
import { UsersService } from 'src/app/services/UsersService';
import { UsersModel } from 'src/app/models/UsersModel';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';         ///----------- for searching pop up -----------

@Component({
  selector: 'app-usersearch',
  templateUrl: './usersearch.component.html',
  styleUrls: ['./usersearch.component.css']
})
export class UsersearchComponent implements OnInit {
  userID ='';
  userName = '';
  enabled =  '';
  empID = '';
  groupCode ='';
  Password ='';
  userID1 = '';
  compCode = '1';
  modifiedDate = '2021-01-01';

  usersList: UsersModel[] = [];

  @Output() submitClicked = new EventEmitter<any>();

  constructor(public dialogRef: MatDialogRef<UsersearchComponent>,     ///----------- for searching pop up -----------
              public usersService: UsersService,
              public users: UsersModel,
              public storage: LocalStorageService,                     /// ----------- Storage
              @Inject(MAT_DIALOG_DATA)                                 ///-----------  For searching pop up -----------
              public usersSelectedData: UsersModel) { }                ///------------ For selection

  ngOnInit(): void {
    this.retriveUsersLookupTop()                                      ///-------------- Start up
  }

  retriveUsersLookup() {
    this.usersList = [];
    this.usersService.getusersLookup(this.userID, this.userName, this.compCode).subscribe((data: UsersModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.usersList[i] = data[i];
      }
     
    })
  }
  retriveUsersLookupTop() {
    this.usersList = [];
    this.usersService.getusersLookupTop(this.compCode).subscribe((data: UsersModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.usersList[i] = data[i];
      }

    })
  }

  SelectUsers(user: UsersModel){                              ///----------- for searching pop up send variables from table-----------

    this.usersSelectedData.userID = user.userID
    this.usersSelectedData.userName = user.userName
    this.usersSelectedData.enabled = user.enabled

    this.usersSelectedData.empID = user.empID
    this.usersSelectedData.groupCode = user.groupCode
    this.usersSelectedData.password = user.password

    this.usersSelectedData.userID1 = user.userID1
    this.usersSelectedData.modifiedDate = user.modifiedDate
    this.usersSelectedData.compCode = user.compCode
    this.submitClicked.emit(this.usersSelectedData);
    this.dialogRef.close();
  }
}
